import React, { Component } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import ReactLoading from 'react-loading';
import { Panel } from 'primereact/panel';
import {Button} from 'primereact/button';

import { CiteService } from '../service/CiteService';
import { BatimentService } from '../service/BatimentService';
import { NiveauService } from '../service/NiveauService';
import { CouloirService } from '../service/CouloirService';
import { ChambreService } from '../service/ChambreService';
import { LitService } from '../service/LitService';
import { VilleService } from '../service/VilleService';
import { AffectationService } from '../service/AffectationService';
import { UtilisateurService } from '../service/UtilisateurService';
import { SessionService } from '../service/SessionService';

export default class ListeAffecteChambre extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ine: '',
      student: null,
      user: null,
      searchMessage: '',
      villes : [],
      selectedVille: null,
      cites: [],
      selectedCite: null,
      session: null,
      batiments: [],
      selectedBatiment: null,
      niveaux: [],
      selectedNiveau: null,
      couloirs: [],
      selectedCouloir: null,
      chambres: [],
      selectedChambre: null,
      lits: [],
      listeExcel: [],
      selectedLit: null,
      occupants: [],  
      litsLibres: [],
      assignedModalVisible: false,
      assignedList: [],
      loading: false
    };

    this.onVilleChange = this.onVilleChange.bind(this);
    this.onCiteChange = this.onCiteChange.bind(this);
    this.onBatimentChange = this.onBatimentChange.bind(this);
    this.onNiveauChange = this.onNiveauChange.bind(this);
    this.onCouloirChange = this.onCouloirChange.bind(this);
    this.onChambreChange = this.onChambreChange.bind(this);
    this.fusionnerTableaux = this.fusionnerTableaux.bind(this);

    this.villeService = new VilleService()
    this.citeService = new CiteService()
    this.batimentService = new BatimentService()
    this.niveauService = new NiveauService()
    this.couloirService = new CouloirService()
    this.chambreService = new ChambreService()
    this.litService = new LitService()
    this.affectationService = new AffectationService()
    this.userService = new UtilisateurService()
    this.sessionService = new SessionService()
  }

  componentDidMount() {
    const data = localStorage.getItem('user')
    if(data){
      const user = JSON.parse(data)
      this.villeService.getVilleDirection(user.idDirection).then(resp => {
        console.log(resp)
        let villes = Array.isArray(resp) ? resp : []
        if(villes.length>0){
           villes = villes.filter(ville => ville.nomVille !== "SAABA");
        }
        this.setState({ villes : villes });
    })
    .catch(error => {
        console.log(error)
    })
      this.setState({user : user})
    }
    
    
  }

  async onVilleChange(e) {
    const ville = e.value;
    this.setState({
      selectedVille: ville,
      cites: [], selectedCite: null,
      batiments: [], selectedBatiment: null,
      niveaux: [], selectedNiveau: null,
      couloirs: [], selectedCouloir: null,
      chambres: [], selectedChambre: null,
      lits: [], selectedLit: null,
      occupants: []
    });
    this.citeService.getCitesVille(ville.idVille).then(data => {
      console.log(data)
      const cites = Array.isArray(data) ? data : []
      this.setState({ cites :  cites});
    })
    .catch(error => {
      console.log(error)
    })
  }
  async onCiteChange(e) {
    const cite = e.value
    this.setState({
      selectedCite: cite,
      batiments: [], selectedBatiment: null,
      niveaux: [], selectedNiveau: null,
      couloirs: [], selectedCouloir: null,
      chambres: [], selectedChambre: null,
      lits: [], selectedLit: null,
      occupants: []
    });

    try {
      const data = await this.batimentService.get(cite.idCite);
      const opts = Array.isArray(data) ? data : [];
      this.setState({ batiments: opts });
    } catch (err) {
      console.error('getBatiments', err);
      this.setState({ batiments: [] });
    }
    const idDirection = this.state.selectedVille.idDirection
    this.sessionService.getSessionDirection(idDirection).then(data => {
      const annees = data
      const maxIdAnnee = annees.reduce((max, item) =>
        item.idAnnee > max.idAnnee ? item : max
      );
      this.setState({session: maxIdAnnee})
    })
    .catch(error => {
      console.log(error.response.data)
    })
  }

  async onBatimentChange(e) {
    const batiment = e.value;
    this.setState({
      selectedBatiment: batiment,
      niveaux: [], selectedNiveau: null,
      couloirs: [], selectedCouloir: null,
      chambres: [], selectedChambre: null,
      lits: [], selectedLit: null,
      occupants: []
    });
    try {
      const data = await this.niveauService.get(batiment.idBatiment);
      const opts = Array.isArray(data) ? data : [];
      this.setState({ niveaux: opts });
    } catch (err) {
      console.error('getNiveaux', err);
      this.setState({ niveaux: [] });
    }
  }

  async onNiveauChange(e) {
    const niveau = e.value;
    this.setState({
      selectedNiveau: niveau,
      couloirs: [], selectedCouloir: null,
      chambres: [], selectedChambre: null,
      lits: [], selectedLit: null,
      occupants: []
    });
    try {
      const data = await this.couloirService.get(niveau.idNiveau);
      const opts = Array.isArray(data) ? data : [];
      this.setState({ couloirs: opts });
    } catch (err) {
      console.error('getCouloirs', err);
      this.setState({ couloirs: [] });
    }
  }

  async onCouloirChange(e) {
    const couloir = e.value;
    console.log(couloir)
    this.setState({
      selectedCouloir: couloir,
      chambres: [], selectedChambre: null,
      lits: [], selectedLit: null,
      occupants: []
    });
    try {
      const data = await this.chambreService.get(couloir.idCouloir);
      const opts = Array.isArray(data) ? data : [];
      this.setState({ chambres: opts });
    } catch (err) {
      console.error('getChambres', err);
      this.setState({ chambres: [] });
    }
  }

  async onChambreChange(e) {
    this.setState({loading : true})
    const chambre = e.value;
    this.setState({ selectedChambre: chambre, lits: [], selectedLit: null, occupants: [] });
    try {
      const lits = await this.litService.get(chambre.idChambre);
      const litOpts = Array.isArray(lits) ? lits: [];
      const occupants = await this.affectationService.getOccupantsByChambre(chambre.idChambre);
      const litsLibres = occupants.litsLibres
      const litsOccupes = occupants.litsOccupes
      const litsChambre = this.fusionnerTableaux(litsLibres, litsOccupes)
      console.log(litsChambre)
      let donneeExcel
      if(litsChambre){
            donneeExcel = litsChambre.map(d => ({'N° Lit' : d.lit.libelleLit, 'N° Chambre' : d.lit.libelleChambre, 'INE' :  d.etudiant.ine, 'Nom' : d.etudiant.nom, 'Prenom' : d.etudiant.prenom, 'Sexe' : d.etudiant.sexe, 'Telephone' : d.etudiant.telephone, 'Filière' : d.etudiant.filiere}))
        }
      this.setState({ lits: litOpts, occupants:  litsChambre});
      this.setState({
            listeExcel : donneeExcel,
            loading : false
        })
    } catch (err) {
      console.error('onChambreChange', err);
      this.setState({ lits: [], occupants: [] });
      this.setState({loading : false})
    }
  }

  fusionnerTableaux(tableauLits, tableauAffectations) {

  const affectationsMap = new Map();

  tableauAffectations.forEach(item => {
    affectationsMap.set(item.lit.idLit, item);
  });

  const etudiantVide = {
    idEtudiant: null,
    ine: "",
    nom: "",
    prenom: "",
    sexe: "",
    filiere: "",
    telephone: ""
  };

  const resultat = [];
  resultat.push(...tableauAffectations);
  tableauLits.forEach(lit => {
    if (!affectationsMap.has(lit.idLit)) {
      resultat.push({
        etudiant: { ...etudiantVide },
        lit: { ...lit }
      });
    }
  });

  return resultat;
}

  exportExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.state.listeExcel);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, "liste_affecte_chambre");   
        });
    }
    saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }

  loadingSpinner = ( type, color) => (
    <ReactLoading type={type} color={color} height={200} width={50} />
  )

  render() {

    return (
      <div className="bed-assignment-module">

        <div className="p-grid" style={{ marginBottom: 12 }}>
          <div className="p-col-3">
            <label>Ville</label><br />
            <Dropdown value={this.state.selectedVille} optionLabel="nomVille" options={this.state.villes} onChange={(e) => {this.onVilleChange(e)}} placeholder="Choisir une ville" />
          </div>
          <div className="p-col-3">
            <label>Cité</label><br />
            <Dropdown value={this.state.selectedCite} optionLabel="nomCite" options={this.state.cites} onChange={(e)=>{this.onCiteChange(e)}} placeholder="Choisir une cité" />
          </div>
          <div className="p-col-3">
            <label>Bâtiment</label><br />
            <Dropdown value={this.state.selectedBatiment} optionLabel="libelleBatiment" options={this.state.batiments} onChange={this.onBatimentChange} placeholder="Choisir un bâtiment" />
          </div>
          <div className="p-col-3">
            <label>Niveau</label><br />
            <Dropdown value={this.state.selectedNiveau} optionLabel="libelleNiveau" options={this.state.niveaux} onChange={this.onNiveauChange} placeholder="Choisir un niveau" />
          </div>
        </div>

        <div className="p-grid" style={{ marginBottom: 12 }}>
          <div className="p-col-3">
            <label>Couloir</label><br />
            <Dropdown value={this.state.selectedCouloir} optionLabel="libelleCouloir" options={this.state.couloirs} onChange={this.onCouloirChange} placeholder="Choisir un couloir" />
          </div>
          <div className="p-col-3">
            <label>Chambre</label><br />
            <Dropdown value={this.state.selectedChambre} optionLabel="libelleChambre" options={this.state.chambres} onChange={this.onChambreChange} placeholder="Choisir une chambre" />
          </div>
        </div>
        {this.state.loading ? 
            <div className="p-grid p-col-12">
                <div className="p-col-6" ></div>
                <div className="p-col-6" >
                    {this.loadingSpinner("spin","black")}
                </div>
            </div>
            :
            <>
                <div className="p-d-flex p-ai-center export-buttons" style={{marginLeft : 10}}>
                    <Button type="button" icon="pi pi-file-excel" onClick={this.exportExcel} className="p-button-success p-mr-2" data-pr-tooltip="XLS" />
                </div>
                <div className='p-grid' style={{"marginTop" : 5}}>
                    <div className='p-col-12'>
                        <Panel header="Lits et occupants (chambre sélectionnée)">
                        <DataTable value={this.state.occupants} paginator rows={10}>
                            <Column field="lit.codeLit" header="Code lit" />
                            <Column field="lit.libelleLit" header="N° Lit" />
                            <Column field="etudiant.ine" header="INE"/>
                            <Column field="etudiant.nom" header="Nom" />
                            <Column field="etudiant.prenom" header="Prénom" />
                            <Column field="etudiant.sexe" header="Sexe" />
                            <Column field="etudiant.telephone" header="Téléphone" />
                            <Column field="etudiant.filiere" header="Filière" />
                        </DataTable>
                        </Panel>
                    </div>
                </div>
            </>
        }
      </div>
    );
  }
}
